@if (isDisplayed) {
<div class="head" [class.inactive]="isNotActive | async">
  @if (region | async | isNotEmpty) {
  <country-flag
    [code]="(region | async).country_iso"
    [tooltip]="(region | async).name"
  ></country-flag>
  <h1>
    <a routerLink="./">{{ name | async }}</a>
  </h1>
  @if (isNotActive | async) {
  <tag [value]="status | async"></tag>
  } }
</div>
<div class="content"><router-outlet></router-outlet></div>
}
